import React, { useState, useEffect, useContext } from 'react'
import { Box, Text } from "grommet"

import AgDataTable from '../common/AgDataTable'
import Spinner from '../common/Spinner'
import { useMarket } from '../../utils/market'
import TriageUrlContext from '../../context/TriageUrlContext'

import axios from 'axios'

import { gql, useSubscription } from '@apollo/client';
import { useDefaultConf } from './TriageHeaders'

const TASK_QUERY = gql`
subscription($taskId: String!) {
    jobtask(where: {taskid: {_eq: $taskId}}) {
        taskid
        result
        status
      }
}
`

const TriageRoutingLibraryResult = ({ content }) => {
    const [result, setResult] = useState(false)
    const [rl, setRL] = useState({})
    const [data, setData] = useState([])
    const [edge, setEdge] = useState("")
    const [instanceId, setInstanceId] = useState("")

    const marketLookup = useMarket()

    const tab_col = [
        {
            field: "name",
            headerName: "TT Application",
            minWidth: 150,
            suppressSizeToFit: true,
            sort: "asc"
        },
        {
            field: "service",
            headerName: "Service Id",
            minWidth: 200,
            suppressSizeToFit: true,
        },
        {
            field: "exch_order_assoc",
            headerName: "Instance Id",
            minWidth: 200,
            suppressSizeToFit: true,
        },
        {
            field: "market",
            headerName: "Market",
            minWidth: 150,
        },
        {
            field: "user_id",
            headerName: "User",
            minWidth: 150,
            hide: true
        }
    ]

    const t3_url = useContext(TriageUrlContext)

    const { data: taskResult, loading: taskDataLoading } = useSubscription(
        TASK_QUERY, { variables: { taskId: content.taskid } }
    )

    const axiosConf = useDefaultConf()

    useEffect(() => {
        if (!taskDataLoading && taskResult && taskResult.jobtask &&
            taskResult.jobtask.length > 0 && taskResult.jobtask[0].status !== 0
            && !(content.taskid.includes("MANUAL"))) {

            async function getStatusResponse() {
                const response = await axios(
                    t3_url + '/api/1/taskstatus/' + content.taskid, axiosConf
                )
                setResult(response.data)
            }

            getStatusResponse()
        }
    }, [axiosConf, content, taskDataLoading, taskResult, t3_url])

    useEffect(() => {
        if (result && result.results && result.results.responses && result.results.responses.length > 0 &&
            result.results.responses[0].wire && result.results.responses[0].wire.payload &&
            result.results.responses[0].wire.payload.length > 0 && result.results.responses[0].wire.payload[0] &&
            result.results.responses[0].wire.payload[0].cli_server
        ) {
            setEdge(result.results.responses[0].wire.payload[0].cli_server.es_hostname.toLowerCase())
            setInstanceId(result.results.responses[0].wire.payload[0].cli_server.server_id)
        }

        if (result && result.results && result.results.responses && result.results.responses.length > 0 &&
            result.results.responses[0].wire && result.results.responses[0].wire.payload &&
            result.results.responses[0].wire.payload.length > 0 && result.results.responses[0].wire.payload[0] &&
            result.results.responses[0].wire.payload[0].output) {
            let routingLibrary = result.results.responses[0].wire.payload[0].output

            // Due to the results showing up in proto/string, need to manually handle the parsing
            // ES=[{(name=algoserver_exec server_id=xxx exch_order_assoc=xx.algoserver_exec user_id=-1 markets=[a, b, c]), 
            let finalResults = []
            let ignoreChars = 5
            let separator = "},"

            // Dropping the first 6 characters
            routingLibrary = routingLibrary.substring(ignoreChars, routingLibrary.length)

            // Splitting by separator
            routingLibrary = routingLibrary.split(separator)

            // Remove the last item
            routingLibrary.pop()

            // Going through each of the routing library entries
            routingLibrary.forEach(rl => {
                // Taking away the first character (
                rl = rl.substring(2, rl.length)
                // Replacing [1, 2, 3] to [1,2,3]
                rl = rl.replace(", ", ",")

                let items = rl.split(" ")
                let values = {}
                items.forEach(kv => {
                    kv = kv.split("=")
                    if (kv.length === 2) {
                        let key = kv[0]
                        let val = kv[1]

                        if (val.includes("[")) {
                            if (val.endsWith(",")) {
                                val = val.substring(0, val.length - 1) + "]"
                            }
                            try {
                                values[key] = JSON.parse(val)
                            } catch (err) {
                                console.log(err)
                            }
                        } else {
                            values[key] = val
                        }
                    }

                })
                finalResults.push(values)
            })
            setRL(finalResults)
        }
    }, [result])

    useEffect(() => {
        if (marketLookup && Object.keys(rl).length > 0) {
            let tab_data = []
            rl.forEach(row => {
                if (row.markets) {
                    for (let marketId of row.markets) {
                        let marketName = ''
                        marketName = marketId === 0 ? '-' : (marketLookup[marketId] ? marketLookup[marketId].name : '-')
                        tab_data.push({
                            "uniqueId": row.exch_order_assoc + ":" + marketName,
                            "market": marketName,
                            "name": row.name,
                            "service": row.server_id,
                            "exch_order_assoc": row.exch_order_assoc
                        })
                    }
                }
            })
            setData(tab_data)
        }
    }, [rl, marketLookup])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Box pad="small" background="light-1">
                <Text size="small" color="brand" weight="bold">Edgeserver {edge} ({instanceId})</Text>
            </Box>
            {!marketLookup
                ? <Spinner />
                :
                <AgDataTable
                    tab_col={tab_col}
                    tab_data={data}
                    tableName="EdgeserverRoutingLibraryView"
                    tableHeight={700}
                />
            }
        </Box>
    )
}

export default TriageRoutingLibraryResult